import { IPluginMetadataSucceededResult } from 'app/apis/plugin-metadata-api.service';
import { format } from 'app/shared/utils/string.util';

const connector: IPluginMetadataSucceededResult = {
    connectorName: 'Asana',
    dataType: 'Hierarchical',
    SupportEncryption: true,
    connectionSettings: [
        {
            type: 'String',
            name: 'apiToken',
            required: true,
            sensitive: true,
            signature: false
        }
    ],
    readSettings: [
        {
            type: 'String',
            name: 'workspaceId',
            displayName: stringResources.Workspace,
            required: true
        },
        {
            type: 'String',
            name: 'entityId',
            displayName: stringResources.DataFlow_Entity,
            required: true
        },
        {
            type: 'String',
            name: 'entityType',
            displayName: stringResources.TableNameDisplay_EntityType,
            required: true
        }
    ],
    writeSettings: [],
    adfAppModelConfiguration: {
        displayName: format(stringResources.ModelName_DisplayTextPreviewTemplate, 'Asana'),
        icon: {
            className: 'svg-i-100x100-asana'
        },
        category: ['ServicesApps'],
        linkedService: {
            properties: [
                'apiToken'
            ],
            uiControls: [
                {
                    bind: 'apiToken',
                    controlType: 'TextBox',
                    displayName: stringResources.ModelName_Token
                }
            ]
        },
        dataflowInlineSource: {
            properties: [
                'workspaceId',
                'entityId',
                'entityType'
            ],
            uiControls: [
                {
                    bind: {
                        schema: 'entityId',
                        workspaceId: 'workspaceId',
                        entityType: 'entityType'
                    },
                    controlType: 'SchemaTableSelection',
                    controlSettings: {
                        properties: [
                            {
                                bind: 'workspaceId',
                                controlType: 'TextBox',
                                displayName: stringResources.Workspace,
                                required: true
                            },
                            {
                                bind: 'entityId',
                                controlType: 'TextBox',
                                displayName: stringResources.DataFlow_Entity,
                                required: true
                            },
                            {
                                bind: 'entityType',
                                controlType: 'DropDown',
                                displayName: stringResources.TableNameDisplay_EntityType,
                                required: true,
                                controlSettings: {
                                    options: [
                                        { label: stringResources.TeamLabel, value: 'teams' },
                                        { label: stringResources.PortfolioLabel, value: 'portfolios' },
                                        { label: stringResources.ProjectLabel, value: 'projects' }
                                    ]
                                }
                            }
                        ],
                        browseSettings: {
                            schemaLabelKey: 'item.name',
                            schemaValueKey: 'item.gid',
                            entityType: 'entityType',
                            workspaceId: 'workspaceId'
                        }
                    }
                }
            ],
            itemSettings: {
                dataflowType: 'asana',
                dataflowFormat: 'rest',
                dataflowUseInlineProjection: true
            }
        }
    }
};

export default connector;
